export default {
	routes: {
		home: {
			path: '/',
			slug: 'home',
			name: 'home',
			transparentHeader: true,
			autoload: true,
		},

		aboutArmenia: {
			path: '/about-armenia/:slug',
			slug: 'page',
			name: 'aboutArmenia',
			singleType: 'singlePage',
			transparentHeader: true,
			autoload: true,
		},

		thingsTodo: {
			path: '/things-to-do/:slug',
			slug: 'page',
			name: 'thingsTodo',
			singleType: 'singlePage',
			transparentHeader: true,
			autoload: true,
		},

		placesToGo: {
			path: '/places-to-go/:slug',
			slug: 'page',
			name: 'placesToGo',
			singleType: 'singlePage',
			transparentHeader: true,
			autoload: true,
		},

		planYourTrip: {
			path: '/plan-your-trip/:slug',
			slug: 'page',
			name: 'planYourTrip',
			singleType: 'singlePage',
			transparentHeader: false,
			autoload: true,
		},

		articles: {
			path: '/articles',
			slug: 'blog',
			name: 'articlesPage',
			autoload: true,
			postType: {
				slug: 'articles',
				name: 'articles',
				queryParamKeys: [null, 'catId'],
			},
		},

		article: {
			path: '/articles/:slug',
			slug: 'articles',
			name: 'article',
			singleType: 'singleArticle',
			transparentHeader: false,
			autoload: true,
		},

		newsRooms: {
			path: '/newsroom',
			slug: 'news-room-page',
			name: 'newsRoomPage',
			autoload: true,
			postType: {
				slug: 'news-rooms',
				name: 'newsRooms',
				queryParamKeys: [],
			},
		},

		newsRoom: {
			path: '/newsroom/:slug',
			slug: 'news-rooms',
			name: 'newsRoom',
			singleType: 'singleNewsRoom',
			transparentHeader: false,
			autoload: true,
		},

		experience: {
			path: '/experiences',
			slug: 'experiences-page',
			name: 'experiencesPage',
			transparentHeader: false,
			autoload: true,
			postType: {
				slug: 'experiences',
				name: 'experiences',
				queryParamKeys: [null, 'catId', 'regionId'],
			},
		},

		singleExperience: {
			path: '/experiences/:slug',
			slug: 'experiences',
			name: 'singleExperience',
			singleType: 'singleExperience',
			transparentHeader: false,
			autoload: true,
		},

		singleDestination: {
			path: '/destination/:slug',
			slug: 'destination',
			name: 'destination',
			singleType: 'singleDestination',
			transparentHeader: false,
			autoload: true,
		},

		map: {
			path: '/map',
			slug: 'map',
			name: 'map',
			transparentHeader: false,
			autoload: true,
		},

		privacyPolicy: {
			path: '/privacy-policy',
			slug: 'privacy-policy',
			name: 'privacy-policy',
			transparentHeader: false,
			autoload: true,
		},

		search: {
			path: '/search',
			slug: 'search',
			name: 'search',
			transparentHeader: false,
			autoload: false,
		},

		contact: {
			path: '/contact-us',
			slug: 'contact-us',
			name: 'contact',
			transparentHeader: false,
			autoload: true,
		},

		events: {
			path: '/events',
			slug: 'events-page',
			name: 'eventsPage',
			autoload: true,
			postType: {
				slug: 'events',
				name: 'events',
				queryParamKeys: ['regionId', 'catId', 'tagIds', 'dates'],
			},
		},

		singleEvent: {
			path: '/events/:slug',
			slug: 'events',
			name: 'event',
			singleType: 'singleEvent',
			autoload: true,
		},

		mediaLibrary: {
			path: '/media-library',
			slug: 'media-library',
			name: 'mediaLibrary',
			autoload: true,
			transparentHeader: false,
			postType: {
				slug: 'medias',
				name: 'medias',
				queryParamKeys: ['type', 'catId', 'orderBy', 'page', 's'],
			},
		},

		bookmarks: {
			path: '/bookmarks',
			slug: 'bookmarks',
			name: 'bookmarks',
			autoload: false,
			transparentHeader: false,
		},

		resetPassword: {
			path: '/reset-password',
			slug: 'reset-password',
			name: 'Reset password',
			autoload: false,
			transparentHeader: false,
		},

		singleLanding: {
			path: '/landing/:slug',
			slug: 'landing',
			name: 'landing',
			singleType: 'singleLanding',
			autoload: true,
		},

		faq: {
			path: '/faq',
			slug: 'faq',
			name: 'faq',
			autoload: true,
		},
	},
};
